import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp, MaskedLine } from "@/components/Reveal";

export default function FinalCTA() {
  const navigate = useNavigate();
  const scrollOrGo = (hash) => {
    if (window.location.pathname === "/") {
      document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/${hash}`);
    }
  };
  return (
    <section data-testid="final-cta" className="bg-navy text-cream relative grain overflow-hidden">
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 py-32 text-center">
        <FadeUp>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Begin</p>
        </FadeUp>
        <h2 className="mt-6 font-serif text-4xl sm:text-6xl font-medium tracking-tight leading-[1.08] max-w-3xl mx-auto">
          <MaskedLine delay={0.1}>Your Australian university</MaskedLine>
          <MaskedLine delay={0.2} className="italic text-gold">journey can start today.</MaskedLine>
        </h2>
        <FadeUp delay={0.3}>
          <p className="mt-8 text-lg text-cream/70 max-w-xl mx-auto leading-relaxed">
            Explore your options, understand the process and make your next decision with confidence.
          </p>
        </FadeUp>
        <FadeUp delay={0.4} className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            data-testid="final-cta-universities"
            onClick={() => navigate("/universities")}
            className="inline-flex items-center gap-3 bg-gold text-navy px-10 py-4 text-sm font-semibold tracking-wide hover:bg-cream transition-colors duration-300"
          >
            Explore Universities <ArrowUpRight className="h-4 w-4" />
          </button>
          <button
            data-testid="final-cta-guidance"
            onClick={() => scrollOrGo("#guidance")}
            className="inline-flex items-center gap-3 border border-cream/30 text-cream px-10 py-4 text-sm font-semibold tracking-wide hover:border-gold hover:text-gold transition-colors duration-300"
          >
            Get Free Guidance
          </button>
        </FadeUp>
      </div>
    </section>
  );
}
